import { alpha } from "@mui/material/styles";
import { buttonClasses } from "@mui/material/Button";
//
import { BUTTON } from "src/config-global";

// ----------------------------------------------------------------------

const COLORS = ["primary", "secondary", "info", "success", "warning", "error", "basic"];

// ----------------------------------------------------------------------

export default function Button(theme) {
    const isLight = theme.palette.mode === "light";

    const rootStyles = (ownerState) => {
        const inheritColor = ownerState.color === "inherit";

        const containedVariant = ownerState.variant === "contained";

        const outlinedVariant = ownerState.variant === "outlined";

        const textVariant = ownerState.variant === "text";

        const softVariant = ownerState.variant === "soft";

        const smallSize = ownerState.size === "small";

        const mediumSize = ownerState.size === "medium";

        const largeSize = ownerState.size === "large";

        const defaultStyle = {
            minWidth: "fit-content",
            ...( inheritColor && {
                // CONTAINED
                ...( containedVariant && {
                    color: isLight ? theme.palette.text.altered : theme.palette.text.primary,
                    backgroundColor: isLight ? theme.palette.text.primary : theme.palette.text.altered,
                    "&:hover": {
                        backgroundColor: isLight ? theme.palette.grey[700] : theme.palette.grey[400]
                    }
                } ),
                // OUTLINED
                ...( outlinedVariant && {
                    borderColor: alpha(theme.palette.common.black, 1),
                    "&:hover": {
                        backgroundColor: theme.palette.action.hover
                    }
                } ),
                // TEXT
                ...( textVariant && {
                    "&:hover": {
                        // backgroundColor: theme.palette.action.hover,
                        backgroundColor: "transparent"
                    }
                } ),
                // SOFT
                ...( softVariant && {
                    color: theme.palette.text.primary,
                    backgroundColor: alpha(theme.palette.grey[500], 0.08),
                    "&:hover": {
                        backgroundColor: alpha(theme.palette.grey[500], 0.24)
                    }
                } )
            } ),
            ...( outlinedVariant && {
                "&:hover": {
                    borderColor: "currentColor",
                    boxShadow: "0 0 0 0.5px currentColor"
                }
            } )
        };

        const colorStyle = COLORS.map((color) => ( {
            ...( ownerState.color === color && {
                // CONTAINED
                ...( containedVariant && {
                    "&:hover": {
                        boxShadow: theme.customShadows[color]
                    }
                } ),
                // SOFT
                ...( softVariant && {
                    color: theme.palette[color][isLight ? "dark" : "light"],
                    backgroundColor: alpha(theme.palette[color].main, 0.16),
                    "&:hover": {
                        backgroundColor: alpha(theme.palette[color].main, 0.32)
                    }
                } ),
                ...( textVariant && {
                    "&:hover": {
                        backgroundColor: "transparent"
                    }
                } )
            } )
        } ));

        const disabledState = {
            [`&.${buttonClasses.disabled}`]: {
                // SOFT
                ...( softVariant && {
                    color: "white",
                    backgroundColor: theme.palette.action.disabledBackground,
                    cursor: "not-allowed"
                } )
            }
        };

        const size = {
            ...( smallSize && {
                height: 38,
                fontSize: 14,
                fontWeight: 400,
                paddingLeft: 15,
                paddingRight: 15,
                ...( textVariant && {
                    // paddingLeft: 4,
                    // paddingRight: 4,
                    width: "fit-content",
                    height: "fit-content",
                    minWidth: "unset",
                    padding: 0
                } )
            } ),
            ...( mediumSize && {
                borderRadius: BUTTON.BASE_RADIUS,
                //
                width: BUTTON.BASE_WIDTH,
                height: BUTTON.BASE_HEIGHT,
                //
                paddingTop: BUTTON.PADDING_Y,
                paddingRight: BUTTON.PADDING_X,
                paddingBottom: BUTTON.PADDING_Y,
                paddingLeft: BUTTON.PADDING_X,
                //
                ...( textVariant && {
                    width: "fit-content",
                    height: "fit-content",
                    minWidth: "unset",
                    padding: 0
                } )
            } ),
            ...( largeSize && {
                height: 48,
                fontSize: 14,
                fontWeight: 400,
                paddingLeft: 16,
                paddingRight: 16,
                ...( textVariant && {
                    // paddingLeft: 10,
                    // paddingRight: 10,
                    width: "fit-content",
                    height: "fit-content",
                    minWidth: "unset",
                    padding: 0
                } )
            } )
        };

        return [defaultStyle, ...colorStyle, disabledState, size];
    };

    return {
        MuiButton: {
            defaultProps: {
                color: "inherit",
                disableElevation: true
            },

            styleOverrides: {
                root: ({ ownerState }) => rootStyles(ownerState)
            }
        }
    };
}
